import Image from "next/image";
import Link from "next/link";
import cls from "./BlogAuthor.module.css";

interface BlogAuthorProps {
    name: string;
    role: string;
    avatar: string;
    href: string;
}

export const BlogAuthor = ({ name, role, avatar, href }: BlogAuthorProps) => {
    const isExternal = href.startsWith("http");

    return (
        <div className={cls.author}>
            <Image
                src={avatar}
                alt={name}
                width={64}
                height={64}
                className={cls.avatar}
            />

            <div className={cls.info}>
                {isExternal ? (
                    <a
                        className={cls.name}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {name}
                    </a>
                ) : (
                    <Link className={cls.name} href={href}>{name}</Link>
                )}
                <span className={cls.role}>{role}</span>
            </div>
        </div>
    );
};
